import api from "@/api"

const state = {
  paymentReports: []
}
const actions = {
  getPaymentReports({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.summary.paymentReports(params).then(
        (response) => {
          commit("setPaymentReports", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  paymentReportsDownload({ _ }, { params }) {
    return new Promise((resolve, reject) => {
      api.summary.paymentReportsDownload(params).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setPaymentReports(state, value) {
    state.paymentReports = value
  }
}
const getters = {
  paymentReports: (state) => state.paymentReports
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
